const sideBardata = [
  {
    title: "Dashboards",
    path: "/dashboard/index",
    icon: (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.99 18H13V11C13 10.447 12.552 9.99996 12 9.99996H6C5.447 9.99996 5 10.447 5 11V18H2L2.006 9.58296L8.998 2.43196L16 9.62396L15.99 18ZM7 18H11V12H7V18ZM17.424 8.18496L9.715 0.300957C9.338 -0.084043 8.662 -0.084043 8.285 0.300957L0.575 8.18596C0.21 8.56096 0 9.08496 0 9.62396V18C0 19.103 0.847 20 1.888 20H6H12H16.111C17.152 20 18 19.103 18 18V9.62396C18 9.08496 17.79 8.56096 17.424 8.18496Z"
      />
    ),
    cName: "nav-text",
  },
  {
    title: "Registration",
    path: "/dashboard/registration",
    icon: (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 5C11.103 5 12 5.897 12 7C12 8.103 11.103 9 10 9C8.897 9 8 8.103 8 7C8 5.897 8.897 5 10 5ZM10 11C12.206 11 14 9.206 14 7C14 4.794 12.206 3 10 3C7.794 3 6 4.794 6 7C6 9.206 7.794 11 10 11ZM10 13C6.141 13 3 16.14 3 20C3 20.552 3.447 21 4 21C4.553 21 5 20.552 5 20C5 17.243 7.243 15 10 15C12.757 15 15 17.243 15 20C15 20.552 15.447 21 16 21C16.553 21 17 20.552 17 20C17 16.14 13.859 13 10 13ZM20 6H21C21.55 6 22 6.45 22 7C22 7.55 21.55 8 21 8H20V9C20 9.55 19.55 10 19 10C18.45 10 18 9.55 18 9V8H17C16.45 8 16 7.55 16 7C16 6.45 16.45 6 17 6H18V5C18 4.45 18.45 4 19 4C19.55 4 20 4.45 20 5V6Z"
      />
    ),

    cName: "nav-text",
  },
  {
    title: "Members",
    path: "/dashboard/members",
    icon: (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 7C16 6.449 15.552 6 15 6C14.448 6 14 6.449 14 7C14 7.551 14.448 8 15 8C15.552 8 16 7.551 16 7ZM18 7C18 8.654 16.654 10 15 10C13.346 10 12 8.654 12 7C12 5.346 13.346 4 15 4C16.654 4 18 5.346 18 7ZM9 4C9 2.897 8.103 2 7 2C5.897 2 5 2.897 5 4C5 5.103 5.897 6 7 6C8.103 6 9 5.103 9 4ZM11 4C11 6.206 9.206 8 7 8C4.794 8 3 6.206 3 4C3 1.794 4.794 0 7 0C9.206 0 11 1.794 11 4ZM11.94 12.046C12.809 11.374 13.879 11 15 11C17.757 11 20 13.243 20 16C20 16.552 19.553 17 19 17C18.447 17 18 16.552 18 16C18 14.346 16.654 13 15 13C14.317 13 13.668 13.234 13.144 13.649C13.688 14.645 14 15.787 14 17C14 17.552 13.553 18 13 18C12.447 18 12 17.552 12 17C12 14.243 9.757 12 7 12C4.243 12 2 14.243 2 17C2 17.552 1.553 18 1 18C0.447 18 0 17.552 0 17C0 13.14 3.141 10 7 10C8.927 10 10.673 10.783 11.94 12.046Z"
      />
    ),

    cName: "nav-text",
  },
  {
    title: "Knowledge Bank",
    path: "/dashboard/knowledge-bank",
    icon: (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 16C2.449 16 2 15.551 2 15C2 14.449 2.449 14 3 14H14V16H3ZM3 2H14V12H3C2.647 12 2.314 12.072 2 12.184V3C2 2.449 2.449 2 3 2ZM15 0H3C1.346 0 0 1.346 0 3V15C0 16.654 1.346 18 3 18H14H15C15.552 18 16 17.552 16 17V16V14V1C16 0.448 15.552 0 15 0Z"
      />
    ),

    cName: "nav-text",
  },
  {
    title: "Billing",
    path: "/dashboard/billing",
    icon: (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 15H7C6.45 15 6 14.55 6 14C6 13.45 6.45 13 7 13H11C11.55 13 12 13.45 12 14C12 14.55 11.55 15 11 15ZM17 15H15C14.45 15 14 14.55 14 14C14 13.45 14.45 13 15 13H17C17.55 13 18 13.45 18 14C18 14.55 17.55 15 17 15ZM20 16C20 16.551 19.552 17 19 17H5C4.448 17 4 16.551 4 16V11H20V16ZM4 8C4 7.449 4.448 7 5 7H19C19.552 7 20 7.449 20 8V9H4V8ZM19 5H5C3.346 5 2 6.346 2 8V16C2 17.654 3.346 19 5 19H19C20.654 19 22 17.654 22 16V8C22 6.346 20.654 5 19 5Z"
      />
    ),

    cName: "nav-text",
  },
  {
    title: "Session",
    path: "/dashboard/session",
    icon: (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 16C7 15.45 7.45 15 8 15C8.55 15 9 15.45 9 16C9 16.55 8.55 17 8 17C7.45 17 7 16.55 7 16ZM12 15H16C16.55 15 17 15.45 17 16C17 16.55 16.55 17 16 17H12C11.45 17 11 16.55 11 16C11 15.45 11.45 15 12 15ZM18 20H6C5.449 20 5 19.551 5 19V13H19V19C19 19.551 18.551 20 18 20ZM6 6H7V7C7 7.55 7.45 8 8 8C8.55 8 9 7.55 9 7V6H15V7C15 7.55 15.45 8 16 8C16.55 8 17 7.55 17 7V6H18C18.551 6 19 6.449 19 7V11H5V7C5 6.449 5.449 6 6 6ZM18 4H17V3C17 2.45 16.55 2 16 2C15.45 2 15 2.45 15 3V4H9V3C9 2.45 8.55 2 8 2C7.45 2 7 2.45 7 3V4H6C4.346 4 3 5.346 3 7V19C3 20.654 4.346 22 6 22H18C19.654 22 21 20.654 21 19V7C21 5.346 19.654 4 18 4Z"
      />
    ),
    cName: "nav-text",
  },
  {
    title: "Account",
    path: "/dashboard/account",
    icon: (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.584 20.6295C16.584 21.2939 16.0651 21.8332 15.4233 21.8332C14.7814 21.8332 14.2626 21.2939 14.2626 20.6295C14.2626 17.3109 11.6591 14.6109 8.45898 14.6109C5.2589 14.6109 2.65541 17.3109 2.65541 20.6295C2.65541 21.2939 2.13657 21.8332 1.4947 21.8332C0.852824 21.8332 0.333984 21.2939 0.333984 20.6295C0.333984 15.9832 3.97979 12.2035 8.45898 12.2035C12.9382 12.2035 16.584 15.9832 16.584 20.6295ZM8.45898 2.57391C9.73925 2.57391 10.7804 3.65363 10.7804 4.98132C10.7804 6.30901 9.73925 7.38873 8.45898 7.38873C7.17871 7.38873 6.13755 6.30901 6.13755 4.98132C6.13755 3.65363 7.17871 2.57391 8.45898 2.57391ZM8.45899 9.79613C11.0195 9.79613 13.1018 7.63669 13.1018 4.98132C13.1018 2.32595 11.0195 0.166504 8.45899 0.166504C5.89845 0.166504 3.81613 2.32595 3.81613 4.98132C3.81613 7.63669 5.89845 9.79613 8.45899 9.79613Z"
      />
    ),
    cName: "nav-text",
  },
];

export default sideBardata;
